/**
 * cortex-admin の workspace user API contract（zod schema + 型）。
 *
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business workspace user picker 候補の API ↔ Web 型を共有する。
 * @graph-connects none
 */
import { z } from 'zod';
/** workspace user picker 候補。 @graph-connects none */
export const WorkspaceUserSchema = z.object({
    id: z.string(),
    email: z.string(),
    name: z.string(),
    nickName: z.string().optional(),
    slackId: z.string().optional(),
});
/** workspace user 一覧レスポンス。 @graph-connects none */
export const WorkspaceUserListSchema = z.array(WorkspaceUserSchema);
//# sourceMappingURL=user.js.map